import React from 'react';
import { FormattedMessage } from 'react-intl';

import { withStyles } from 'src/app/helpers/styles';

@withStyles(require('./OverlayNewVideo.scss'))
export class OverlayNewVideo extends React.Component {
  render(): JSX.Element {
    return (
      <FormattedMessage id="label.video.new">
        {(message) => <span className="bg-secondary fg-white fs-10 fs@md-16 fw-500 position-absolute bottom-0 left-0 tt-uppercase ta-center py-4 px-8 overlay-new-video">{message}</span>}
      </FormattedMessage>
    );
  }
}
